import cmpStatus from "../../cmp-status";
import cmp, {site} from "../../context/context";
import {CMP_ID, CMP_VERSION} from "../../cmp/cmp";
import cmpConfig from "../../cmp-config";

interface ISelectable {
    [key:number]:boolean;
}

interface IOOB {
    allowedVendors:ISelectable;
    disclosedVendors:ISelectable;
}

interface IPurpose {
    consents:ISelectable;
    legitimateInterests:ISelectable;
}

interface IVendor {
    consents:ISelectable;
    legitimateInterests:ISelectable;
}

interface ITCData {
    tcString:string;
    tcfPolicyVersion:number;
    cmpId: number;
    cmpVersion: number;
    gdprApplies:boolean|undefined;
    eventStatus?:string;
    cmpStatus:string;
    listenerId?:number;
    isServiceSpecific:boolean;
    useNonStandardStacks:boolean;
    publisherCC:string;
    purposeOneTreatment:boolean;
    outOfBand:IOOB;
    purpose:IPurpose;
    vendor:IVendor;
    specialFeatureOptins:ISelectable;
}

class TCData implements ITCData{

    public static build(vendorIds:number[] = []) : TCData
    {
        return new TCData(vendorIds);
    }

    tcString:string;
    tcfPolicyVersion:number;
    cmpId: number;
    cmpVersion: number;
    gdprApplies:boolean|undefined;
    eventStatus?:string;
    cmpStatus:string;
    listenerId?:number;
    isServiceSpecific:boolean;
    useNonStandardStacks:boolean;
    publisherCC:string;
    purposeOneTreatment:boolean;
    outOfBand:IOOB;
    purpose:IPurpose;
    vendor:IVendor;
    specialFeatureOptins:ISelectable;
    addtlConsent?:string;

    private constructor(vendorIds:number[] = []) {
        this.tcString = cmp().tcString?.toString()??"";
        this.tcfPolicyVersion = cmpStatus.tfcPolicyVersion??0;
        this.cmpId = CMP_ID;
        this.cmpVersion = CMP_VERSION;
        this.gdprApplies = cmpConfig.gdprApplies;
        this.eventStatus = cmpStatus.eventStatus;
        this.cmpStatus = cmpStatus.cmpStatus;
        this.isServiceSpecific = cmpConfig.serviceSpecific;
        this.useNonStandardStacks = false;
        this.publisherCC = site.country.toUpperCase();
        this.purposeOneTreatment = false;
        this.outOfBand = {
            allowedVendors: {},
            disclosedVendors: {}
        };
        this.purpose = {
            consents: {},
            legitimateInterests: {}
        };
        this.vendor = {
            consents: {},
            legitimateInterests: {}
        };
        this.specialFeatureOptins = {};

        if (cmpStatus.cmpLoaded) {
            // Purposes consents
            cmp().tcString?.acceptedPurposes().forEach((purposeId: number) => {
                this.purpose.consents[purposeId] = true;
            });
            // Purposes LI
            cmp().tcString?.acceptedPurposesLI().forEach((purposeId: number) => {
                this.purpose.legitimateInterests[purposeId] = true;
            });
            // SpecialFeaturesOptin
            cmp().tcString?.acceptedSpecialFeatures().forEach((featureId: number) => {
                this.specialFeatureOptins[featureId] = true;
            });
            // Vendors
            vendorIds.forEach((vendorId: number) => {
                // Vendors constents
                this.vendor.consents[vendorId] = cmp().tcString?.vendors[vendorId] ?? false;
                // Vendors LI
                this.vendor.legitimateInterests[vendorId] = cmp().tcString?.vendorsLI[vendorId] ?? false;
            });
            this.addtlConsent = cmp().addtlConsent?.decodedString()
        }
    }
}

export {TCData}
